"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipContentLinkProperty = exports.tipContentLinkPropertyDefinition = void 0;
exports.tipContentLinkPropertyDefinition = {
    view: {
        label: 'Author',
        hint: 'Link tip to an Artist, Athlete, Photographer or Judge',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'artist',
                'athlete',
                'judge',
                'photographer',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'tip-content-link',
};
const isTipContentLinkProperty = (prop) => {
    return prop.name === exports.tipContentLinkPropertyDefinition.name;
};
exports.isTipContentLinkProperty = isTipContentLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLWNvbnRlbnQtbGluay5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RpcC1jb250ZW50LWxpbmsucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsUUFBUTtRQUNmLElBQUksRUFBRSx1REFBdUQ7S0FDOUQ7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixRQUFRO2dCQUNSLFNBQVM7Z0JBQ1QsT0FBTztnQkFDUCxjQUFjO2FBQ2Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxrQkFBa0I7Q0FDTyxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=